import script from "./SectionHtmlText.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHtmlText.vue?vue&type=script&setup=true&lang=js"

import "./SectionHtmlText.vue?vue&type=style&index=0&id=fade4762&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fade4762"]])

export default __exports__